module.exports = __webpack_public_path__ + "static/media/Cover4.6bb85224.jpg";